/*
* @Author: LiuMouLiang
* @Date:   2023-04-04 16:22:03
* @class:  使用控制器
*/
import {
    getObjVal,
    typeOf,
    _for,
    _getStr,
    _toNumber,
    isEmptyObject,
} from 'tools';
import {
    toJson,
    trace,
} from './base';
import {
    getFrontControlInfoToProductMsg,
    getIsJumpWritePageToBaseInfo,
} from './works';
import {
    globalControlConfig,
    set_globalControlConfig,
    set_insurePageConfig,
    set_bqPageConfig,
    set_frontControlInfo,
    control_notInsuredPeopleNum,
    control_notInsuredAgeRange,
    control_notInsuredCareer,
    control_isInsuranceConstructionProduct,
    control_calculateNeedInsureHouseAddress,
    control_quotePageConfig,
    control_invoicePageConfig,
    control_detailPageConfig,
    needMailInsuranceForm
} from './control';

//设置全局控制器
//因为服务端无法统一数据，所以只能区分类型
export const set_globalControlConfig_productMsg = function(productMsg, configs){
    const {
        productId,
    } = productMsg || {};
    if(!productId) {
        console.error(Error('没有产品id无法处理特殊产品'));
        return false;
    }
    let res = {
        productId: _getStr(productId),
    };
    globalControlConfig['productId'] = res.productId;
    if(!typeOf(configs, 'object')){
        configs = {
            type: '', // bq - 保全
        };
    };
    const isConfigBqType = configs.type === 'bq'; //是否是保全配置
    let insurePageConfig = {};
    let bqPageConfig = {};

    /* 写死控制 */
    control_notInsuredPeopleNum(res.productId, res);
    control_notInsuredAgeRange(res.productId, res);
    control_notInsuredCareer(res.productId, res);

    control_isInsuranceConstructionProduct(res.productId, res);
    control_calculateNeedInsureHouseAddress(res.productId, res);

    control_quotePageConfig(res.productId, res);
    control_detailPageConfig(res.productId, res);
    needMailInsuranceForm(res.productId, res);

    /* 服务端控制 */
    /*
    personJobAttribute: 1-高空
    */

    const groupProductConfigDTO = getObjVal(productMsg, 'groupProductConfigDTO');
    const productBaseInfo = getObjVal(productMsg, 'base');
    if(groupProductConfigDTO) {
        res['isHighSkyInsuredPeople'] = groupProductConfigDTO.personJobAttribute == 1 ? true : false;
    }else if(isConfigBqType) {
        res['isHighSkyInsuredPeople'] = productMsg.personJobAttribute == 1 ? true : false;
        bqPageConfig['isRefuseIncludeJob'] = productMsg.isRefuseIncludeJob == 1 ? true : false;
        res['supportAddJob'] = productMsg.supportAddJob == 1 ? true : false;
    };
    if(productBaseInfo){
        const productConfigType = productBaseInfo['configType'] || 1;
        res['isCustomCalculate'] = productBaseInfo.isCustomCalculate == 1;
        res['salesType'] = _toNumber(productBaseInfo.salesType) || -1;
        res['productType'] = _toNumber(productBaseInfo.productType) || 0;
        insurePageConfig['isJumpWritePage'] = getIsJumpWritePageToBaseInfo(productBaseInfo);
        insurePageConfig['isNewConfigType'] = productConfigType == 6;

    }else if(isConfigBqType) {
        res['isCustomCalculate'] = productMsg.isCustomCalculate == 1;
    };

    /* 前端控制 */
    const frontControlInfo = getFrontControlInfoToProductMsg(productMsg);
    const {
        isSpecialCustomizedProduct,
        isGetQuoteHideFast,
    } = frontControlInfo;
    control_invoicePageConfig(frontControlInfo, res);
    set_frontControlInfo(frontControlInfo, res);
    set_insurePageConfig(insurePageConfig, res);
    set_bqPageConfig(bqPageConfig, res);

    res['isSpecialCustomizedProduct'] =
        isSpecialCustomizedProduct ||
        res.productId === '60103' ||
        false;
    res.quotePageConfig['isGetQuoteHideFast'] = isGetQuoteHideFast || false;


    // trace('设置全局控制器 === ', res, frontControlInfo);
    return set_globalControlConfig(res, 'setings接口配置 === '+ (isConfigBqType && '保全'));
};

// 保全重新设置api接口的数据
export const BQ_setApi_globalControlConfig_productMsg = function(productMsg){
    const productId = getObjVal(productMsg, 'productId');
    if(!productId) return false;
    set_globalControlConfig_productMsg(productMsg, {type: 'bq'});
    const {
        invoicePageConfig,
        isCustomCalculate,
    } = globalControlConfig;
    // 特殊处理-自定义计算是设置为第三方算费配置
    if(isCustomCalculate) {
        productMsg.isThirdTrial = 1;
    };
    // 特殊处理-保全展示关闭时发票数据不存在
    //退费需要发票信息，即便为空
    if(invoicePageConfig.isShowIssueBeforeBq === false || isEmptyObject(invoicePageConfig)){
        if(productMsg.billInfoBean) {
            productMsg.billInfoBean = null;
        }
    };
    return productMsg;
};



// WEBPACK FOOTER //
// ./src/libs/util/control-use.js